/** Local fallback when join-battle HTTP succeeds but the socket countdown event is missed. */
export const DIRECT_CHALLENGE_COUNTDOWN_EVENT = 'eclipsera:pvp-direct-challenge-countdown'

export type DirectChallengeCountdownDetail = {
  challengeId?: string
  roomId?: string
  countdownSeconds?: number
  serverNowMs?: number
  countdownEndsAtUnixMs?: number
  needsPayment?: boolean
}

export function dispatchDirectChallengeCountdown(detail: DirectChallengeCountdownDetail): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(DIRECT_CHALLENGE_COUNTDOWN_EVENT, { detail }))
}
